import { ETAB_NUMBER_SUB_DETAIL } from 'models/subscription';

interface TAB_SUBSCRIPTION_DETAIL_TYPE {
  label: string;
  isDisable: boolean;
  tabIndex: ETAB_NUMBER_SUB_DETAIL;
}

export const subDetailTab: TAB_SUBSCRIPTION_DETAIL_TYPE[] = [
  {
    label: 'Sitter',
    isDisable: false,
    tabIndex: ETAB_NUMBER_SUB_DETAIL.SITTERS,
  },
  {
    label: 'Concierge Jobs',
    isDisable: false,
    tabIndex: ETAB_NUMBER_SUB_DETAIL.JOBS,
  },
  {
    label: 'Purchase History',
    isDisable: false,
    tabIndex: ETAB_NUMBER_SUB_DETAIL.PURCHASE_HISTORY,
  },
];
